import * as S from '@components/preview/views/Unilink/styled.js';
import httpClient from '@utils/httpClient.js';
import { getUnlinkItemMap } from '@utils/mapper.js';
import React from 'react';

export const addAnimation = ({ bounce, mobileView = null, viewType, postLayout, markup }) => {
  switch (bounce) {
    case 'pulse': {
      return <S.Pulse mobileView={mobileView}>{markup}</S.Pulse>;
    }
    case 'shake': {
      return <S.Shake mobileView={mobileView}>{markup}</S.Shake>;
    }
    case 'tada': {
      return <S.Tada mobileView={mobileView}>{markup}</S.Tada>;
    }
    case 'bounceIn': {
      return <S.BounceIn mobileView={mobileView}>{markup}</S.BounceIn>;
    }
    case 'fadeIn': {
      return <S.FadeIn mobileView={mobileView}>{markup}</S.FadeIn>;
    }
    case 'flipInX': {
      return <S.FlipInX mobileView={mobileView}>{markup}</S.FlipInX>;
    }
    case 'flipInY': {
      return <S.FlipInY mobileView={mobileView}>{markup}</S.FlipInY>;
    }
    case 'zoomIn': {
      return <S.ZoomIn mobileView={mobileView}>{markup}</S.ZoomIn>;
    }
    case 'swing': {
      return <S.Swing mobileView={mobileView}>{markup}</S.Swing>;
    }
    case 'jello': {
      return <S.Jello mobileView={mobileView}>{markup}</S.Jello>;
    }
    default: {
      return (
        <S.NoAnimate mobileView={mobileView} viewType={viewType} postLayout={postLayout}>
          {markup}
        </S.NoAnimate>
      );
    }
  }
};

export function checkIsPreview() {
  const { href } = window.location;
  return href.includes('?preview');
}

export function checkIsTimestamp() {
  const { href } = window.location;
  return href.includes('t=');
}

export function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export function hexToRgbAOld(hex, opacity) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${opacity})`;
  }
}

export function hexToRgbA(color, opacity) {
  const isHexColor = /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
  const isRgbColor = /^rgb\(/.test(color);
  const isRgbaColor = /^rgba\(/.test(color);

  if (isRgbaColor) {
    return color.replace(/[\d.]+\)$/, `${opacity})`);
  } else if (isRgbColor) {
    return color.replace(')', `, ${opacity})`).replace('rgb', 'rgba');
  } else if (isHexColor) {
    let c = color.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const hexToRgb = '0x' + c.join('');
    const [r, g, b] = [(hexToRgb >> 16) & 255, (hexToRgb >> 8) & 255, hexToRgb & 255];
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  } else {
    return `rgba(255, 255, 255, 1)`;
  }
}

export function getMiddleGradientColor(hex, opacity) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${opacity})`;
  }
}

export function checkFillCustomForm(isField, isFieldRequired, value) {
  return isField && isFieldRequired ? value.length > 0 : true;
}

export function copyDirectMessage(message) {
  navigator.clipboard.writeText(message);
}

export function copyLink() {
  const tempInput = document.createElement('input');
  tempInput.value = window.location.href;
  tempInput.style.position = 'absolute';
  tempInput.style.top = '0';
  tempInput.style.left = '0';
  document.body.appendChild(tempInput);

  tempInput.focus();
  tempInput.select();

  document.execCommand('copy');
  document.body.removeChild(tempInput);
}

export function getIconTitle(Icon) {
  let title = Icon.split('.')[0];

  if (title.includes('-')) {
    title = title.split('-')[1];
  }

  return title[0].toUpperCase() + title.slice(1);
}

export function changeMapSize(mapCode, width = 400, height = 300) {
  let updatedMapCode = '';

  const widthPos = mapCode.indexOf('width=');
  const heightPos = mapCode.indexOf('height=');
  updatedMapCode = mapCode.slice(0, widthPos) + `width="${width}"` + mapCode.slice(widthPos + 11);
  updatedMapCode = updatedMapCode.slice(0, heightPos) + `height="${height}"` + updatedMapCode.slice(heightPos + 12);
  return updatedMapCode;
}

/*-------- Payments system  --------*/

export function runFondy(id, type) {
  let path;

  switch (type) {
    case 'digital':
      path = 'api/fondy/digital/checkout';
      break;
    case 'appointments':
      path = 'api/fondy/appointment/checkout';
      break;
    case 'request':
      path = 'api/fondy/request/checkout';
      break;
    case 'donation':
      path = 'api/fondy/donation/checkout';
      break;
    default:
      path = 'api/fondy/checkout';
  }

  httpClient
    .get(`${path}/${id}`)
    .then((res) => {
      console.log(res);

      const { data: link } = res;
      window.location.href = link;
      // window.open(link);
    })
    .catch((error) => {
      console.log(error);
    });
}

export function checkSupportedWayForPay(currencyCode) {
  return currencyCode === 'AED' || currencyCode === 'BRL' || currencyCode === 'INR';
}

export function checkSupportedPayPal(currencyCode) {
  return currencyCode === 'AED' || currencyCode === 'UAH' || currencyCode === 'INR';
}

export function getSupportedCurrency(paymentSystem, currencyCode) {
  if (paymentSystem === 'WayForPay') {
    if (checkSupportedWayForPay(currencyCode)) {
      return 'USD';
    }

    return currencyCode;
  } else if (paymentSystem === 'PayPal') {
    if (checkSupportedPayPal(currencyCode)) {
      return 'USD';
    }

    return currencyCode;
  } else return currencyCode;
}

export function getCurrencyConvert(code, amount) {
  return httpClient.get(`api/currency/convert?code=${code}&amount=${amount}`);
}

export function getHeightPostLayout(layout) {
  switch (layout) {
    case 0:
      return 12;
    case 1:
      return 92;
    case 2:
      return 142;
    case 3:
      return 190;
    case 4:
      return 145;
    default:
      return 12;
  }
}

export function loadMoreShopItems({ userId, skipItems, provider, setSkip, setIsShowingButton, setList, setIsLoading = () => null }) {
  setIsLoading(true);

  httpClient.get(`api/shop-products?id=${userId}&take=${20}&skip=${skipItems}&provider=${provider}&active=true`).then((res) => {
    if (res && res.data) {
      const { data } = res;

      const newItems = data.map((el) => getUnlinkItemMap(el));

      if (newItems.length < 20) {
        setIsShowingButton(false);
      }

      setList((prevItems) => [...prevItems, ...newItems]);
      setSkip(skipItems + 20);
    }

    setIsLoading(false);
  });
}

export function getMarginBottomPhotoBox(layout) {
  switch (layout) {
    case 0:
      return '16px';
    case 1:
      return '106px';
    case 2:
      return '146px';
    case 3:
      return '210px';
    case 4:
      return '156px';
    default:
      return '16px';
  }
}

export function getMarginBottomPhotoBoxMobile(layout) {
  switch (layout) {
    case 0:
      return '12px';
    case 1:
      return '104px';
    case 2:
      return '146px';
    case 3:
      return '200px';
    case 4:
      return '152px';
    default:
      return '12px';
  }
}

export function getTextColor(color) {
  switch (color) {
    case '#000':
      return '#ffffff';
    case '#fff':
      return '#000000';
    case 'black':
      return '#ffffff';
    case 'white':
      return '#000000';
    default:
      break;
  }

  if (color) {
    try {
      const { r, g, b } = hexToRgb(color);
      if (r * 0.299 + g * 0.587 + b * 0.114 > 125) {
        return '#000';
      } else {
        return '#fff';
      }
    } catch (error) {
      console.log('error of getTextColor', error);

      switch (color) {
        case '#000':
          return '#ffffff';
        case '#fff':
          return '#000000';
        case 'black':
          return '#ffffff';
        case 'white':
          return '#000000';
        default:
          break;
      }
    }
  } else return '#000';
}

export function getContactName(Type) {
  let messenger = 'Messenger';

  switch (Type) {
    case 1:
      messenger = 'Messenger';
      break;
    case 2:
      messenger = 'WhatsApp';
      break;
    case 3:
      messenger = 'Viber';
      break;
    case 5:
      messenger = 'Telegram';
      break;
    case 6:
      messenger = 'Twitter';
      break;
    case 7:
      messenger = 'Phone';
      break;
    case 8:
      messenger = 'Email';
      break;
    case 9:
      messenger = 'Location';
      break;
    case 10:
      messenger = 'Instagram';
      break;
    case 11:
      messenger = 'Skype';
      break;
    default:
      break;
  }

  return messenger;
}
